<template>
  <div class="min-wrap flex-center bg-teacher" style="overflow:hidden;">
    <div class="wrap-container pt50">
      <p class="index_classify">
        <span>专家团队</span>
      </p>
      <div class="index_swiper">
        <swiper
            :space-between="swiper_options.space_between"
            :navigation="swiper_options.navigation"
            :autoplay="swiper_options.autoplay"
            :loop="swiper_options.loop"
            :pagination="swiper_options.pagination"

        >
          <swiper-slide v-for="i in Math.ceil(list.length/5)" :key="i">
            <div class="box">
              <div class="teacher-card" v-for="(item) in list.slice((i-1)*5, i*5)">
                <img :src="getImg(item.imgName)">
                <div class="flex-col flex-center">
                  <h1>{{item.name}}</h1>
                  <div>{{item.title}}</div>
                  <div class="sep-line-v"></div>
                  <p v-html="item.description"></p>
                </div>
              </div>
            </div>
          </swiper-slide>
          <div class="swiper-pagination"></div>
          <img src="../assets/images/Index/swiperArrow.png" class="swiper-button-next">
          <img src="../assets/images/Index/swiperArrow.png" class="swiper-button-prev">
        </swiper>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import {reactive, ref} from "vue";
import SwiperCore, {Navigation, Autoplay,Pagination} from "swiper";
import {Swiper, SwiperSlide} from 'swiper/vue'
import "swiper/scss";
import "swiper/scss/navigation";
// 新增分页样式导入
import "swiper/scss/pagination";
SwiperCore.use([Navigation, Autoplay,Pagination]);
interface ITeacher {
  name: string;
  title: string;
  description: string;
  imgName:string
}

// 轮播图配置
const swiper_options: any = reactive({
  slides_per_view: 4,
  space_between: 10,
  // autoplay: {
  //   delay: 3000,
  //   disableOnInteraction: true
  // },
  autoplay:false,
  loop: false,
  navigation: {
    nextEl: '.swiper-button-next', //前进后退按钮
    prevEl: '.swiper-button-prev',
  },
  pagination: {  // 新增分页配置
    el: '.swiper-pagination',
    clickable: true,
  },
});
const list = ref<ITeacher[]>([
  {
    imgName: '1',
    name: '宋承敏',
    title: '国家发改委教授研究员',
    description: '国家宏观经济管理<br/>编辑部副主任'
  },
  {
    imgName: '2',
    name: '王小广',
    title: '经济学博士',
    description: '中共中央党校（国家行政学院）<br/>经济学部副主任'
  },
  {
    imgName: '3',
    name: '王喜文',
    title: '博士后、高级工程师',
    description: '京华夏工联网智能技术研究院院长 <br/>工业4.0研究所所长'
  },
  {
    imgName: '4',
    name: '傅思明',
    title: '教授、博士生导师',
    description: '中央党校政法教研部宪法<br/> 与行政法教研室主任'
  },
  {
    imgName: '5',
    name: '李良栋',
    title: '中央党校政法教研部教授',
    description: '研究社会主义民主政治、 <br/>西方政治思潮、政治文化理论'
  },
  {
    imgName: '6',
    name: '牛广瀑',
    title: '工程技术应用研究员',
    description: '山东省有突出贡献的中青年专家<br/>山东省科技进步先进工作者'
  },
  {
    imgName: '7',
    name: '宋柏允',
    title: '宏观经济解读专家',
    description: '东方华尔金融教育高级研究员<br/>华尔街通科技金融战略分析师'
  },
  {
    imgName: '8',
    name: '马兆林',
    title: '互联网顶层智慧研究院院长',
    description: '北京大学、清华大学<br/>等知名高校特约讲师'
  },
  {
    imgName: '9',
    name: '周新军',
    title: '管理学博士、经济学博士后',
    description: '南开大学企业管理专业博士<br/>中国社会科学院应用经济学博士后'
  },
  {
    imgName: '10',
    name: '李军',
    title: '北京工商大学硕士生导师',
    description: '原住建部建设部部长<br/>高级经济师、副研究员'
  },
  {
    imgName: '11',
    name: '纪柚安',
    title: '副教授、硕士生导师',
    description: '任教于河北科技大学<br/>化学工程与技术专业硕士学位'
  },
  {
    imgName: '12',
    name: '李俊',
    title: '副教授',
    description: '安徽理工大学教授<br/>经济学博士'
  },
  {
    imgName: '13',
    name: '李喜琴',
    title: '国家卫健委党校研究员',
    description: '主要研究医院党建<br/>医院廉政建设等'
  },
  {
    imgName: '14',
    name: '王政',
    title: '清华大学思想文化史硕士',
    description: '北京大学学士<br/>美国访问学者'
  },
  {
    imgName: '15',
    name: '苏英',
    title: '北京大学医学部心理学系讲师',
    description: '中国心理学会注册心理师<br/>精神分析学派学者'
  },
  {
    imgName: '16',
    name: '陈霞',
    title: '博士、学科化学专家',
    description: '北京师范大学博士、副教授，拥有<br/>专业及教材教法研究十七年'
  },
  {
    imgName: '17',
    name: '靳澎',
    title: '国家二级心理咨询师',
    description: '从事心理咨询、教师培训<br/>等工作十余年'
  },
  {
    imgName: '18',
    name: '朱涛',
    title: '教授、建筑师',
    description: '美国哥伦比亚大学建筑硕士<br/>建筑历史理论专业博士'
  },
  {
    imgName: '19',
    name: '王子健',
    title: '一级建造师、建筑经济师',
    description: '多年参与一级、二级建造师<br/>培训与编写等方面的工作'
  },
  {
    imgName: '20',
    name: '廖光哲',
    title: '一级建造师、中级经济师',
    description: '毕业于南京航空航天大学<br/>硕士研究生学历'
  }
])
const getImg = (name: string) => {
  // console.log('图片最终路径：', new URL(`@/assets/images/teacher/${name}.png`, import.meta.url).href); // 检查路径是否正确
  // console.log('图片最终路径1111：', new URL(`@/assets/images/teacher/1.png`, import.meta.url).href); // 检查路径是否正确
  // return new URL(`@/assets/images/teacher/${name}.png`, import.meta.url).href
  return require(`@/assets/images/teacher/${name}.png`);
}

const onresize = () => {
  swiper_options.slides_per_view = 5
}

window.onresize = onresize
onresize()
</script>

<style scoped lang="scss">
.bg-teacher {
  background: center/cover url('@/assets/images/bg-teacher.png');
  //background: #FFFFFF;
}
.index_swiper {
  position: relative;
  margin-bottom: 50px;
  > div {
    position: initial;
    margin: 0 40px;
  }

  .swiper-slide {
    box-sizing: border-box;
   // padding-top: 20px;
  .box{
    height: 400px;
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
  }
    .teacher-card {
      width: 96%;
      transition: transform 0.3s ease; // 添加过渡效果
      transform-origin: center; // 设置变换原点为中心
      height: 340px;
      background: #FFFFFF;
      padding-top: 20px;
      border-radius: 4px;
      img {
        height: 170px;
        display: block;
        margin: 0 auto;
      }

      div {
        margin: 8px 0;
        text-align: center;

        h1 {
          color: #5888e9;
          font-weight: bold;
          font-size: 20px;
          margin-right: 10px;
        }

        p {
          padding: 0 0px 10px 0;
          color: #333;
          font-size: 14px;
          line-height: 22px;
        }
      }
    }

    // 鼠标滑过卡片时放大
    .teacher-card:hover {
      transform: scale(1.1); // 放大1.05倍
      background: #0d84ff;
      color: #fff;
      h1,div,p{
        color: #fff;
      }
      .sep-line-v{
        background: #ffff;
      }
    }
  }

  .swiper-button-prev, .swiper-button-next {
    width: 35px;
    height: 35px;
  }

  .swiper-button-next {
    right: 0px;
    transform: rotate(180deg);
  }

  .swiper-button-prev {
    left: 0px;
  }
}
.index_classify {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 30px;

  img {
    width: 44px;
    margin-right: 5px;
  }

  span {
    font-weight: bold;
    font-size: 32px;
  }
}
.sep-line-v {
  height: 2px;
  width: 40px;
  background: #5888e9;
}
:deep(.swiper-pagination){
  // 定位到轮播底部
  position: absolute;
  bottom: -30px; // 调整距离轮播底部的距离
  left: 0;
  right: 0;
  text-align: center;
}
.swiper-pagination {
  // 定位到轮播底部
  position: absolute;
  bottom: -30px; // 调整距离轮播底部的距离
  left: 0;
  right: 0;
  text-align: center;
}
</style>